export function combatStatusRotationDelta(dt: number, wakeInvuln: number): number {
  if (!Number.isFinite(dt) || dt < 0) throw new RangeError('combat status frame delta must be finite and non-negative')
  if (!Number.isFinite(wakeInvuln) || wakeInvuln < 0) throw new RangeError('wake invulnerability must be finite and non-negative')
  return dt * (wakeInvuln > 0 ? 2.4 : 0.7)
}

export function combatStatusPulse(elapsedTime: number, wakeInvuln: number): number {
  if (!Number.isFinite(elapsedTime) || elapsedTime < 0) throw new RangeError('combat status elapsed time must be finite and non-negative')
  if (!Number.isFinite(wakeInvuln) || wakeInvuln < 0) throw new RangeError('wake invulnerability must be finite and non-negative')
  return 1 + Math.sin(elapsedTime * (wakeInvuln > 0 ? 22 : 9)) * 0.05
}
